import {Consumer} from '../services/api'
import { SET_PASSWORD_ERROR} from "../redux/reducers/changePasswordForm";
import {TOGGLE_PAYMENT_EDIT, USER_UPDATED} from "../redux/reducers/layout";
import {getObjectKeyName} from "../utils/common";
import {SET_USER_FORM_ERROR} from "../redux/reducers/userEditFrom";
import {User} from "../redux/reducers/user";
import {SET_CARD_ERROR} from "../redux/reducers/creditCardForm";

interface Login {
    email: string,
    password: string
}

export const userRegisterFormChange = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: 'USER_REGISTER_FORM_ADD_CHANGE', ...data})
    }
};

export const resetUserRegisterForm = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: 'RESET_REGISTER_FORM', ...data})
    }
};

export const userLoginFormChange = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: 'USER_LOGIN_FORM_ADD_CHANGE', ...data})
    }
};

export const resetUserLoginForm = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: 'RESET_LOGIN_FORM', ...data})
    }
};

export const getUserInfo = () => {
    return async (dispatch: any) => {
        try {
            const payload = await Consumer.me();
            return dispatch({type: 'GET_USER_INFO', payload})
        } catch (e) {
            return dispatch({type: 'GET_USER_ERROR', payload: e})
        }
    }
};

export const login = (data: Login) => {
    return async (dispatch: any) => {
        try {
            dispatch({type: 'RESET_USER_ERROR', payload: {}});
            const payload = await Consumer.login(data);
            localStorage.setItem('token', payload.token);
            return dispatch({type: 'GET_USER_INFO', payload})
        } catch (e) {
            return dispatch({type: 'USER_LOGIN_ERROR', payload: e})
        }
    }
};

export const update = (data: User) => {
    return async (dispatch: any) => {
        try {
            const payload = await Consumer.update(data);
            dispatch({type: 'GET_USER_INFO', payload});
            dispatch({type: USER_UPDATED, payload: true});
            return dispatch({type: 'TOGGLE_USER_EDIT'});
        } catch (e:any) {
            return dispatch({type: SET_USER_FORM_ERROR, payload: e.data.message})
        }
    }
};

export const resetUser = () => {
    return (dispatch: any) => {
        dispatch({type: 'RESET_USER_ERROR', payload: {}});
        return dispatch({type: 'GET_USER_INFO', payload: {}});
    }
};

export const uploadAvatar = (data: any) => {
    return async (dispatch: any) => {
        try {
            dispatch({type: 'AVATAR_LOADING', payload: true});
            await Consumer.uploadAvatar(data);
            const payload = await Consumer.me();
            dispatch({type: 'GET_USER_INFO', payload});
            dispatch({type: 'USER_UPDATED', payload: true});
            return dispatch({type: 'AVATAR_LOADING', payload: false});
        } catch (e:any) {
            dispatch({type: 'AVATAR_LOADING', payload: false});
            return dispatch({type: 'USER_LOGIN_ERROR', payload: e})
        }
    }
};

export const removeAvatar = () => {
    return async (dispatch: any) => {
        try {
            dispatch({type: 'AVATAR_LOADING', payload: true});
            await Consumer.removeAvatar();
            const payload = await  Consumer.me();
            dispatch({type: 'GET_USER_INFO', payload});
            dispatch({type: 'USER_UPDATED', payload: true});
            return dispatch({type: 'AVATAR_LOADING', payload: false})
        } catch (e:any) {
            dispatch({type: 'AVATAR_LOADING', payload: false});
            return dispatch({type: 'USER_LOGIN_ERROR', payload: e})
        }
    }
};

export const userEditFormChange = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: 'USER_EDIT_FORM_CHANGE', ...data})
    }
};

export const resetUserEditForm = () => {
    return (dispatch: any) => {
        return dispatch({type: 'RESET_EDIT_FORM'})
    }
};

export const deleteUser = () => {
    return async () => {
        await Consumer.deleteUser();
        localStorage.removeItem('token');
        return window.location.href = '/';
    }
};

export const cancelDeleteUser = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: 'CANCEL_USER_DELETE', payload: data})
    }
};

export const changePasswordForm = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: 'CHANGE_PASSWORD', ...data})
    }
};

export const changePassword = (data: any) => {
    return async (dispatch: any) => {
        try {
            await Consumer.changePassword(data);
            dispatch({type: 'RESET_CHANGE_PASSWORD'});
            dispatch({type: 'USER_UPDATED', payload: true});
            return dispatch({type: 'CLOSE_EDIT_PASSWORD'});
        } catch (e:any ) {
            const errType = getObjectKeyName(data, 'oldPassword');
            dispatch({type: SET_PASSWORD_ERROR, payload: {...e.data, errType}})
        }
    }
};

export const userExist = (data: any) => {
    return async (dispatch: any) => {
        try {
            const payload = await Consumer.userExist(data);
            return dispatch({type: 'USER_EXIST', payload})
        } catch (e) {
            return dispatch({type: 'USER_EXIST_ERROR', payload: e})
        }
    }
};

export const updatePayment = (data: any) => {
    return async (dispatch: any) => {
        try {
            await Consumer.updatePayment(data);
            const payload = await Consumer.me();
            dispatch({type: 'USER_UPDATED', payload: true});
            dispatch({type: 'GET_USER_INFO', payload});
            return dispatch({type: TOGGLE_PAYMENT_EDIT})
        } catch (e:any) {
            console.log(data);
            const errType = getObjectKeyName(data, 'number');
            dispatch({type: SET_CARD_ERROR, payload: {...e.data, errType}});
        }
    }
};

export const unsubscribe = (data: any) => {
    return async (dispatch: any) => {
        await Consumer.unsubscribe(data);
        return dispatch({type: 'UNSUBSCRIBE', action: true})
    }
};

export const resubscribe = (data: any) => {
    return async (dispatch: any) => {
        await Consumer.unsubscribe({...data, action: 'resub'});
        return dispatch({type: 'UNSUBSCRIBE', action: false})
    }
};

export const forgotPassword = (data: any) => {
    return async (dispatch: any) => {
        try {
            const payload = await Consumer.forgotPassword(data);
            return dispatch({type: 'FORGET_PASSWORD', payload})
        } catch (e:any) {
            return dispatch({type: 'FORGET_PASSWORD_ERROR', payload: e})
        }
    }
};

export const forgotPasswordToken = (token: any) => {
    return async (dispatch: any) => {
        try {
            let payload = await Consumer.checkResetPassToken(token);

            payload = !!payload.success;

            return dispatch({type: 'CHECK_RESET_PASS_TOKEN', payload})
        } catch (e:any) {
            return dispatch({type: 'CHECK_RESET_PASS_TOKEN_ERROR', payload: e})
        }
    }
};

export const resetPassword = (data: any) => {
    return async (dispatch: any) => {
        try {
            const payload = await Consumer.resetPassword(data);
            return dispatch({type: 'RESET_PASSWORD', payload})
        } catch (e:any) {
            return dispatch({type: 'RESET_PASSWORD_ERROR', payload: e})
        }
    }
};

export const changeForgotPasswordForm = (data: any) => {
    return (dispatch: any) => {
            return dispatch({type: 'FORGOT_PASSWORD_FORM_CHANGE', ...data})
    }
};

export const resetForgotPasswordForm = () => {
    return async (dispatch: any) => {
            return dispatch({type: 'RESET_FORGOT_PASSWORD'})
    }
};
